import React, { useRef, useState, useEffect } from "react";
import addDrivingLicense from "../../../../../../../assets/images/addDriver/addDrivingLicense.svg";
import "./AddDriverInput.scss";
import AddInputField from "app/views/commonComponents/AddInputField/AddInputField";
import RadioButtonGroup from "app/views/commonComponents/RadioButtonGroup/RadioButtonGroup";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import Icon from "app/views/commonComponents/Icon/Icon";
import toastIcon from "../../../../../../../assets/images/poc/toastIcon.svg";
import toastCross from "../../../../../../../assets/images/poc/toastCross.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import InputDropdown from "app/views/commonComponents/InputDropdown/InputDropdown";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import {
  GoogleMap,
  useJsApiLoader,
  LoadScript,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import HomeAddress from "app/views/commonComponents/HomeAddress/HomeAddress";
import { addDriverData } from "../../../../../../apiServices/apiServices";
const AddDriverInput = ({ onClose, onDriverAdd }) => {
  const [driverId, setDriverId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [suffix, setSuffix] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState();
  const [preferredName, setPreferredName] = useState("");
  const [mobileNumber, setMobileNumber] = useState();
  const [emailAddress, setEmailAddress] = useState("");
  const [homeAddress, setHomeAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setSate] = useState("");
  const [zip, setzip] = useState();
  const [plan, setPlan] = useState("A");
  const [selectedFrontImage, setSelectedFrontImage] = useState(null);
  const [selectedBackImage, setSelectedBackImage] = useState(null);
  const fileFrontInputRef = useRef(null);
  const fileBackInputRef = useRef(null);
  const [drivingLicense, setDrivingLicense] = useState("");
  const [driverClassification, setDriverClassification] = useState("");
  const [initalHireDate, setInitalHireDate] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [validMobileNumber, setValidMobileNumber] = useState(false);
  const [validZipNumber, setValidZipNumber] = useState(false);
  const [validDate, setValidDate] = useState(false);
  const [selectedHomeAddress, setSelectedHomeAddress] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDriverAdded, setIsDriverAdded] = useState(false);
  const planOptions = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    // { value: "C", label: "C" },
  ];
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 28.7041,
    lng: 77.1025,
  });
  const addressesList = [
    "123 Main Street, Anytown, NY 12345",
    "456 Oak Avenue, Springfield, IL 67890",
    "789 Maple Drive, Lakeside, CA 90123",
    "321 Pine Street, Rivertown, TX 45678",
    "987 Elm Court, Mountainview, CO 23456",
    "654 Cedar Lane, Oceanview, FL 78901",
    "321 Birch Road, Hillside, WA 34567",
    "876 Walnut Street, Hillcrest, OR 56789",
    "543 Spruce Avenue, Sunset, GA 67890",
    "210 Sycamore Lane, Lakeside, TN 12345",
    "999 Pinecrest Drive, Riverdale, AL 67890",
    "777 Maple Avenue, Parkside, VA 23456",
    "888 Oak Street, Hilltop, SC 34567",
    "111 Elm Road, Riverside, MS 45678",
    "222 Cedar Lane, Lakeshore, KY 56789",
    "333 Birch Avenue, Hillcrest, LA 67890",
    "444 Spruce Court, Valleyview, OH 12345",
    "555 Walnut Drive, Lakeside, NC 23456",
    "666 Pine Lane, Hillview, AZ 34567",
    "777 Elm Street, Oakdale, NV 45678",
  ];

  const fileFrontSelectHandler = (event) => {
    const file = event.target.files[0];
    setSelectedFrontImage(file);
    //setOpenCrop(true);
    //onFrontImageSelect(file); // Pass selected front image to parent component
    event.target.value = null;
    // Handle file upload
  };
  const fileBackSelectHandler = (event) => {
    const file = event.target.files[0];
    setSelectedBackImage(file);
    //onBackImageSelect(file); // Pass selected back image to parent component
    event.target.value = null;
    // Handle file upload
  };
  const handleButtonFrontClick = () => {
    fileFrontInputRef.current.click();
  };
  const handleButtonBackClick = () => {
    fileBackInputRef.current.click();
  };
  const handleFirstNameChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z]*$/;
    if (regex.test(inputValue)) {
      setFirstName(inputValue);
    }
  };
  const handleLastNameChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z]*$/;
    if (regex.test(inputValue)) {
      setLastName(inputValue);
    }
  };
  const handleMiddleNameChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z]*$/;

    if (regex.test(inputValue)) {
      setMiddleName(inputValue);
    }
  };
  const handleSuffixChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z]*$/;

    if (regex.test(inputValue)) {
      setSuffix(inputValue);
    }
  };
  const handlePreferredNameChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z\s]*$/;
    if (regex.test(inputValue)) {
      setPreferredName(inputValue);
    }
  };
  const handleCityChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z\s]*$/;

    if (regex.test(inputValue)) {
      setCity(inputValue);
    }
  };
  const handleStateChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression to match only alphabetic characters
    const regex = /^[A-Za-z\s]*$/;

    if (regex.test(inputValue)) {
      setSate(inputValue);
    }
  };
  const handleZipChange = (e) => {
    const inputValue = e.target.value;
    const trimmedValue = inputValue.slice(0, 5); // Limit to 5 digits
    const validZipNumber = trimmedValue.length === 5; // Check if it contains exactly 10 digits
    setValidZipNumber(validZipNumber);
    setzip(trimmedValue);
  };
  const handleDateOfBirthChange = (e) => {
    let inputValue = e.target.value;

    // Check if the user pressed the backspace key
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      // Remove the last character if it's not a slash
      if (inputValue.charAt(inputValue.length - 1) !== "/") {
        inputValue = inputValue.slice(0);
      }
    } else {
      // Remove any non-digit characters and slashes
      inputValue = inputValue.replace(/[^\d/]/g, "");

      // Insert slash after the month (mm) and day (dd) if not already present
      if (
        (inputValue.length === 2 || inputValue.length === 5) &&
        inputValue.charAt(inputValue.length - 1) !== "/"
      ) {
        inputValue += "/";
      }

      // Format the date as mm/dd/yyyy
      if (inputValue.length > 2 && inputValue.length <= 4) {
        inputValue = inputValue.replace(/(\d{2})(\d{2})/, "$1/$2");

        // Validate month
        const mm = inputValue.substring(0, 2);
        // if (parseInt(mm) > 12) {
        //   return; // Return without making any changes if month is invalid
        // }
      } else if (inputValue.length > 4 && inputValue.length <= 10) {
        //inputValue = inputValue.replace(/(\d{2})(\d{2})(\d{4})/, "$1/$2/$3");

        // Validate month and day
        const mm = inputValue.substring(0, 2);
        const dd = inputValue.substring(3, 5);
        // if (parseInt(mm) > 12 || parseInt(dd) > 31) {
        //   return; // Return without making any changes if month or day is invalid
        // }
      } else if (inputValue.length > 10) {
        // If input exceeds 10 characters (including slashes), return without making any changes
        return;
      }
    }

    // Update the state with the formatted value
    setDateOfBirth(inputValue);
  };
  const handleMobileNumberChange = (e) => {
    const rawValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const limitedValue = rawValue.slice(0, 10); // Limit to 10 digits
    console.log("limitedValue", limitedValue);
    const validMobileNumber = limitedValue.length === 10; // Check if it contains exactly 10 digits
    setValidMobileNumber(validMobileNumber);
    const formattedValue = limitedValue.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    ); // Format as (555) 222-3333
    setMobileNumber(formattedValue); // Update the state with the formatted value
  };
  // Function to handle email address change
  const handleEmailAddressValid = () => {
    // Regular expression for email validation
    //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    //const emailAddress = event.target.value;
    if (!emailRegex.test(emailAddress)) {
      // Invalid email address format
      console.log("EmailAddress1");
      setValidEmail(false);
    } else {
      // Valid email address format
      console.log("EmailAddress2", emailAddress);
      setValidEmail(true);
    }
  };
  const handleEmailAddressChange = (e) => {
    const inputValue = e.target.value;
    // Regular expression for validating email addresses
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    setEmailAddress(inputValue);
    // handleEmailAddressValid();
  };
  // Function to handle changes in showDropdown value
  const handleShowDropdownChange = (showDropdownValue) => {
    // Update the showDropdownParent value in the parent component
    setShowDropdown(showDropdownValue);
  };
  const handleHomeAddressSelection = (selectedValue) => {
    setSelectedHomeAddress(selectedValue);
  };
  useEffect(() => {
    handleEmailAddressValid(); // Call validation function on component mount and whenever emailAddress changes
  }, [emailAddress]);
  const addDriverDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    const driverData = {
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      preferred_name: preferredName,
      email: emailAddress,
      phone_number: mobileNumber,
      plan_id: plan,
      home_address: homeAddress,
      suffix: suffix,
      city: city,
      state: state,
      zip: zip,
      date_of_birth: dateOfBirth,
      driver_classification: driverClassification,
      inital_hire_date: initalHireDate,
    };
    // fetch(
    //   "https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/drivers",
    //   {
    //     method: "POST",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       firstName: firstName,
    //       middleName: middleName,
    //       lastName: lastName,
    //       preferred_name: preferredName,
    //       email: emailAddress,
    //       phone_number: mobileNumber,
    //       plan_id: plan,
    //       home_address: homeAddress,
    //       suffix: suffix,
    //       city: city,
    //       state: state,
    //       zip: zip,
    //       date_of_birth: dateOfBirth,
    //       driver_classification: driverClassification,
    //       inital_hire_date: initalHireDate,
    //     }),
    //   }
    // )
    addDriverData(driverData)
      // .then((result) => {
      // if (result.status === 200) {
      //   return result.json();
      // } else {
      //   alert("Please check login credentials!");
      // }
      // })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          console.log("isDriverAdded0", isDriverAdded);
          handleAddDriverStatus(true);
          setIsDriverAdded(true);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          //return result.json();
        }
        console.log("addVehicleData", response.data);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const handleAddDriverStatus = (value) => {
    console.log("isDriverAdded1", value);
    onDriverAdd(value);
  };
  // useEffect(() => {
  //   if (isDriverAdded) {
  //     // Call the callback function passed from the parent
  //     console.log("isDriverAdded1", isDriverAdded);
  //     onDriverAdd(isDriverAdded);
  //   }
  // }, [isDriverAdded, onDriverAdd]);
  console.log("isDriverAdded2", isDriverAdded);
  return (
    <>
      <>
        {/* <div className="licenseImageSection">
        <div className="frontSideUploadSection" style={{ width: "" }}>
          <div className="frontSideTitle">
            <div className="dlStyle">Driving License</div>
            <div className="fsStyle"> Front Side</div>
          </div>

          <div className="frontSideUploadInput">
            {selectedFrontImage ? (
              <>
                <div className="imageWrapper">
                  <CropEasy
                  {...{
                    selectedFrontImage,
                    setOpenCrop,
                    setSelectedFrontImage,
                    setFile,
                  }}
                />
                  <img
                    src={URL.createObjectURL(selectedFrontImage)}
                    alt="Selected"
                    style={{ maxWidth: "100%", maxHeight: "200px" }}
                  />
                  <Buttons
                    size="regular"
                    buttonType="secondary"
                    dimensions={"responsive"}
                    iconPosition={"left"}
                    image={addDrivingLicense}
                    width={"auto"}
                    onClick={handleButtonFrontClick}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "auto",
                    }}
                  >
                    Upload Driving Licence
                  </Buttons>
                </div>
              </>
            ) : (
              <Buttons
                size="regular"
                buttonType="secondary"
                dimensions={"responsive"}
                iconPosition={"left"}
                image={addDrivingLicense}
                width={"auto"}
                onClick={handleButtonFrontClick}
              >
                Upload Driving Licence
              </Buttons>
            )}
            <input
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              onChange={fileFrontSelectHandler}
              ref={fileFrontInputRef}
            />
          </div>
        </div>
        <div className="backSideUploadSection" style={{ width: "" }}>
          <div className="frontSideTitle">
            <div className="dlStyle">Driving License</div>
            <div className="fsStyle"> Back Side</div>
          </div>
          <div className="frontSideUploadInput">
            {selectedBackImage ? (
              <div className="imageWrapper">
                <img
                  src={URL.createObjectURL(selectedBackImage)}
                  alt="Selected"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
                <Buttons
                  size="regular"
                  buttonType="secondary"
                  dimensions={"responsive"}
                  iconPosition={"left"}
                  image={addDrivingLicense}
                  width={"auto"}
                  onClick={handleButtonBackClick}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "auto",
                  }}
                >
                  Upload Driving Licence
                </Buttons>
              </div>
            ) : (
              <Buttons
                size="regular"
                buttonType="secondary"
                dimensions={"responsive"}
                iconPosition={"left"}
                image={addDrivingLicense}
                width={"auto"}
                onClick={handleButtonBackClick}
              >
                Upload Driving Licence
              </Buttons>
            )}
            <input
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              onChange={fileBackSelectHandler}
              ref={fileBackInputRef}
            />
          </div>
        </div>
        <AddInputField
          fieldName="Driving License No."
          fieldValue={drivingLicense}
          onChange={(e) => setDrivingLicense(e.target.value)}
          style={{ width: "100%" }}
        />
      </div> */}
      </>
      <div className="inputSectionDriver">
        <div className="inputRowDriver">
          {/* <AddInputField
            fieldName="Driver Id"
            fieldValue={driverId}
            onChange={(e) => setDriverId(e.target.value)}
            style={{ width: "100%" }}
          /> */}
          <AddInputField
            fieldName="First Name"
            fieldValue={firstName}
            inputType="text"
            //onChange={(e) => setFirstName(e.target.value)}
            onChange={handleFirstNameChange}
            style={{ width: "100%" }}
            autoComplete="given-name"
          />
          <AddInputField
            fieldName="Middle Name"
            fieldValue={middleName}
            inputType="text"
            //onChange={(e) => setMiddleName(e.target.value)}
            onChange={handleMiddleNameChange}
            style={{ width: "100%" }}
          />
          <AddInputField
            fieldName="Last Name"
            fieldValue={lastName}
            inputType="text"
            // onChange={(e) => setLastName(e.target.value)}
            onChange={handleLastNameChange}
            style={{ width: "100%" }}
            autoComplete="family-name"
          />
          <AddInputField
            fieldName="Suffix"
            fieldValue={suffix}
            inputType="text"
            //onChange={(e) => setSuffix(e.target.value)}
            onChange={handleSuffixChange}
            style={{ width: "100%" }}
          />
        </div>
        <div
          className="inputRowDriver"
          style={{
            display: "flex",
          }}
        >
          <div style={{ flex: "1" }}>
            <AddInputField
              fieldName="Home Address"
              fieldValue={homeAddress}
              inputType="textarea"
              onChange={(e) => setHomeAddress(e.target.value)}
              autoComplete="home street-address"
            />
            {/* <InputDropdown
              fieldName="Home Address"
              dropdownOptions={addressesList}
              initialValue={selectedHomeAddress}
              onValueSelection={handleHomeAddressSelection}
              setShowDropdownParent={handleShowDropdownChange}
            /> */}
            {/* <HomeAddress
              setSelectedLocation={setSelectedLocation}
            ></HomeAddress> */}
            {/* <SearchLocationInput setSelectedLocation={setSelectedLocation} /> */}
            {/* <GooglePlacesAutocomplete apiKey="AIzaSyCj9hR4ijU4BYkh-ugnYLfwShnmug-7wrM" /> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flex: "1",
              gap: "24px",
            }}
          >
            <div style={{ flex: "1" }}>
              <AddInputField
                fieldName="City"
                fieldValue={city}
                inputType="text"
                //onChange={(e) => setCity(e.target.value)}
                onChange={handleCityChange}
                autoComplete="address-level2"
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "24px",
                flex: "1",
              }}
            >
              <AddInputField
                fieldName="State"
                fieldValue={state}
                inputType="text"
                //onChange={(e) => setSate(e.target.value)}
                onChange={handleStateChange}
                autoComplete="address-level1"
              />
              <AddInputField
                fieldName="Zip"
                fieldValue={zip}
                inputType={"number"}
                onChange={handleZipChange}
                autoComplete="postal-code"
              />
            </div>
          </div>
        </div>
        <div className="inputRowDriver" style={{ width: "100%" }}>
          <AddInputField
            fieldName="Date Of Birth"
            fieldValue={dateOfBirth}
            inputType="text"
            onChange={handleDateOfBirthChange}
            placeholder="mm/dd/yyyy"
            style={{ width: "100%" }}
            autoComplete="bday"
            zIndex={showDropdown == true && "-1"}
          />
          <AddInputField
            fieldName="Preferred Name"
            fieldValue={preferredName}
            inputType="text"
            //onChange={(e) => setPreferredName(e.target.value)}
            onChange={handlePreferredNameChange}
            style={{ width: "100%" }}
            zIndex={showDropdown == true && "-1"}
          />
          <AddInputField
            fieldName="Mobile Phone Number"
            fieldValue={mobileNumber}
            inputType="text"
            onChange={handleMobileNumberChange}
            style={{ width: "100%" }}
            autoComplete="tel"
          />
          <AddInputField
            fieldName="Email Address"
            fieldValue={emailAddress}
            inputType="email"
            onChange={handleEmailAddressChange}
            style={{ width: "100%" }}
            autoComplete="email"
          />
        </div>
      </div>
      <div className="loginCTABox">
        <div className="payPlan">
          <RadioButtonGroup
            fieldName="Pay Plan"
            options={planOptions}
            selectedOption={plan || "A"}
            onChange={setPlan}
          />
        </div>
        <Buttons
          size={"small"}
          dimensions={"normal"}
          buttonType={"primary"}
          // disabled={
          //   (firstName == "" ||
          //     lastName == "" ||
          //     dateOfBirth == null ||
          //     validMobileNumber == false ||
          //     validEmail == false ||
          //     homeAddress == "" ||
          //     city == "" ||
          //     state == "" ||
          //     validZipNumber == false) &&
          //   true
          // }
          onClick={() => {
            addDriverDataAPI();
            // toast("Driver is added.", {
            //   position: toast.POSITION.TOP_CENTER,
            // });
            onClose();
          }}
        >
          Submit
        </Buttons>
      </div>
      <ToastContainer
        className={"toast-message"}
        toastStyle={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 12px 8px 8px",
          background: "rgba(0, 188, 249, 0.1)",
          borderRadius: "54px",
          color: "#00bfff",
          fontFamily: "Red Hat Text",
          fontSize: "14px",
          fontWeight: "600",
          //height: "36px",
          minHeight: "none",
        }}
        hideProgressBar={true}
        closeButton={<img src={toastCross} />}
        icon={<img src={toastIcon} />}
      />
    </>
  );
};

export default AddDriverInput;
